import React from 'react';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import { forTemplate } from 'app/common/lib/util/i18n';
import Icon, { IconName } from 'app/common/components/controls/icon';
import styles from './upsell-advanced-checklist.less';
import cx from 'classnames';
import Util from 'app/scripts/lib/util/index.coffee';
import { trackUe, Noun, Verb } from '@trello/analytics';
import { UpgradePromptButtonConnected } from 'app/src/components/UpgradePrompts/UpgradePromptButton';

const format = forTemplate('upsell_advanced_checklist');

interface Props {
  upgradeUrl: string;
  onUpgrade(): void;
}

export function AdvancedChecklistUpsell({ upgradeUrl, onUpgrade }: Props) {
  return (
    <div className={styles.acContainer} key="acContainer">
      <div className={cx(styles.text, 'informational')} key="information">
        <p className={styles.checklistTitle}>
          {format('supercharge-your-checklists-with-bc')}
        </p>
        <p className="information">{format('with-advanced-checklists')}</p>
        <div className="feedback-section" key="feedback-section" />
        <div className={styles.upgradeWrapper}>
          <UpgradePromptButtonConnected
            shouldFitContainer
            cta={format('upgrade')}
            ctaLink={upgradeUrl}
            ctaOnClick={onUpgrade}
            openInNewTab
          />
        </div>
      </div>
      <div className="bc-features" key="bc-features">
        <p className={styles.bcGetTitle}>{format('more-features-you-get')}</p>
        <div className={cx(styles.iconDiv, 'boards')}>
          <div className={styles.iconStyling} key="boards">
            <Icon name={IconName.Board} className={styles.icon} small />
          </div>
          <span className={styles.iconInfo} key="unlimited-team-boards">
            {format('unlimited-team-boards')}
          </span>
        </div>
        <div className={cx(styles.iconDiv, 'powerups')} key="powerups">
          <div className={styles.iconStyling} key="powerups">
            <Icon name={IconName.PowerUp} className={styles.icon} small />
          </div>
          <span className={styles.iconInfo} key="unlimited-powerups">
            {format('unlimited-power-ups')}
          </span>
        </div>
        <div className={cx(styles.iconDiv, 'butler')} key="butler">
          <div className={styles.iconStyling} key="butler">
            <Icon name={IconName.ButlerBot} className={styles.icon} small />
          </div>
          <span className={styles.iconInfo} key="advanced-automation">
            {format('advanced-automation')}
          </span>
        </div>
        <div className={cx(styles.iconDiv, 'security')} key="security">
          <div className={styles.iconStyling} key="security-icon">
            <Icon name={IconName.Add} className={styles.icon} small />
          </div>
          <span className={styles.iconInfo} key="extra-security">
            {format('extra-security')}
          </span>
        </div>
      </div>
      <div className={styles.bcLink} key="bc-link">
        {
          <a
            href="/business-class"
            target="_blank"
            onClick={() =>
              trackUe({
                category: Noun.BUSINESS_CLASS_ADVANCED_CHECKLIST_UPSELL,
                verb: Verb.OPENS,
                directObj: Noun.BUSINESS_CLASS_MARKETING_PAGE,
                method: 'by clicking learn more button',
              })
            }
          >
            {format('learn-more')}
          </a>
        }
      </div>
    </div>
  );
}

interface Options {
  trackingMethod: string;
  billingUrl: string | undefined;
}

export function toggleUpsellAdvancedChecklist({
  trackingMethod,
  billingUrl,
}: Options) {
  return function toggle(e: MouseEvent) {
    Util.stop(e);

    trackUe(
      Noun.CARD_DETAIL,
      Verb.OPENS,
      Noun.BUSINESS_CLASS_ADVANCED_CHECKLIST_UPSELL,
      'on checkitem',
      '',
      trackingMethod,
    );

    PopOver.toggle({
      elem: e.currentTarget,
      keepEdits: true,
      hideHeader: true,
      reactElement: (
        <AdvancedChecklistUpsell
          key="advanced-checklists-info"
          upgradeUrl={billingUrl ?? '/business-class'}
          onUpgrade={() =>
            trackUe({
              category: Noun.BUSINESS_CLASS_ADVANCED_CHECKLIST_UPSELL,
              verb: Verb.OPENS,
              directObj: billingUrl
                ? Noun.TEAM_PAGE_BC_TAB
                : Noun.BUSINESS_CLASS_MARKETING_PAGE,
              method: 'by clicking upgrade button',
            })
          }
        />
      ),
    });
  };
}
